module.exports = __webpack_public_path__ + "img/info.c36cc96e.svg";